import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "input"]

  connect() {
    this.requireAtLeastOne()
  }

  onInputChange(e) {
    this.requireAtLeastOne()
  }

  requireAtLeastOne() {
    const areAllInputsBlank = this.inputTargets.every((i) => !i.value)

    this.fieldTargets.forEach((f) => {
      const input = f.querySelector("input:not([type='hidden'])")
      const label = f.querySelector("label")

      if (!input || !label) {
        return
      }

      const labelText = label.innerText.replace(/\*/g, "").trim()

      if (areAllInputsBlank) {
        label.innerText = `${labelText}*`.trim()
        input.setAttribute("required", "")
      } else {
        label.innerText = labelText
        input.removeAttribute("required")
      }
    })
  }

  showAll(e) {
    e.currentTarget.classList.add("hidden")

    this.fieldTargets.forEach((t) => {
      t.classList.remove("hidden")
    })
  }
}
